import { Link } from "react-router-dom";
import SubscribeForm from "@/components/feature/SubscribeForm";
import { siteInfo } from "@/mocks/gossip";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "瓜田广场", to: "/plaza" },
  { label: "蹲后续", to: "/#follow" },
  { label: "关于我们", to: "/about" },
];

const topicLinks = [
  { label: "娱乐八卦", to: "/plaza?category=yule" },
  { label: "影视综艺", to: "/plaza?category=yingshi" },
  { label: "社会热点", to: "/plaza?category=shehui" },
  { label: "音乐潮流", to: "/plaza?category=yinyue" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-primary-800 text-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-500 text-xl font-bold text-primary-950">
                瓜
              </span>
              <span className="font-heading text-lg font-bold">{siteInfo.name}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              {siteInfo.intro}
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-background-200">
              <i className="ri-mail-line text-base" aria-hidden="true"></i>
              <span>联系邮箱：{siteInfo.email}</span>
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold">快速导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="transition-colors hover:text-secondary-300">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold">热门板块</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200">
              {topicLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="transition-colors hover:text-secondary-300">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div id="follow" className="mt-12 rounded-lg border border-primary-600 bg-primary-900/60 p-5 md:p-7">
          <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-md">
              <h3 className="font-heading text-lg font-bold text-background-50">订阅蹲后续提醒</h3>
              <p className="mt-2 text-sm text-background-200">
                留下邮箱，当正在跟进的时间线出现新进展时，我们会优先把整理好的后续发给你。
              </p>
            </div>
            <div className="w-full lg:max-w-md">
              <SubscribeForm />
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-600 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} {siteInfo.name} · 吃瓜群众集合地</p>
          <p>本站内容仅为公开信息梳理与观点分享，不构成任何事实认定或法律意见。</p>
        </div>
      </div>
    </footer>
  );
}